export const PublishServiceLogsDefaultValue = (clientsData) => {
 
    return {
        school_id : ""
    }
  
}

export default PublishServiceLogsDefaultValue